import { render, staticRenderFns } from "./LegacyInvoice.vue?vue&type=template&id=6b675b4d&"
import script from "./LegacyInvoice.vue?vue&type=script&lang=js&"
export * from "./LegacyInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports